import useTextDirection from 'utils/hooks/useTextDirection'
import ProgressBar from './ProgressBar'
import HeaderTitle from './HeaderTitle'
import LastChance from './LastChance'
import Head from './Head'
import HeaderImage from './HeaderImage'

const Layout: React.FC = ({ children }) => {
  const dir = useTextDirection()

  return (
    <div>
      <Head />
      <header className="pt-6 px-7 max-w-md mx-auto" dir={dir}>
        <HeaderImage/>
        <ProgressBar />
        <HeaderTitle />
      </header>
      <main className="pb-12 sm:pb-20" dir={dir}>{children}</main>
      <LastChance />
    </div>
  )
}

export default Layout
